export var ALL_ENTRIES = [];
export function observe(type, callback, options) {
    if (typeof PerformanceObserver === "function" &&
        PerformanceObserver.supportedEntryTypes.includes(type)) {
        var po = new PerformanceObserver(function (list) {
            list.getEntries().forEach(function (entry) { return callback(entry); });
        });
        po.observe(Object.assign({ type: type, buffered: true }, { options: options }));
        return po;
    }
    return undefined;
}
export function getEntries(type) {
    return ALL_ENTRIES.filter(function (entry) { return entry.entryType === type; });
}
export function addEntry(entry) {
    ALL_ENTRIES.push(entry);
}
export function clearEntries() {
    ALL_ENTRIES.splice(0);
}
